import {AgeLimit} from '@/js/util/constants'

/**
 * @file editUserInputValidationRules
 * 【管理画面】顧客情報修正モーダルのバリデーション定義
 */

/**
 * 【管理画面】顧客情報修正モーダルのバリデーションルール
 * @param {object} common
 * @param {object} unique
 */
export const ValidationRulesFun = (common, unique) => {
  const copy = JSON.parse(JSON.stringify(common))
  for (let key in unique) {
    if (common[key]) {
      copy[key].push(...unique[key])
    } else {
      copy[key] = unique[key]
    }
  }
  return copy
}

/**
 * 【管理画面】顧客情報修正モーダルのバリデーション共通
 */
export const ValidationRulesCommon = {
  // 申込日(年)
  application_date_year: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_month:application_date_day', event: 'blur', error_add: 'application_date'}
  ],
  // 申込日(月)
  application_date_month: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_year:application_date_day', event: 'blur', error_add: 'application_date'}
  ],
  // 申込日(日)
  application_date_day: [
    {rule: 'required', event: 'blur', action: 'select', error_add: 'application_date'},
    {rule: 'date:application_date_month:application_date_year', event: 'blur', error_add: 'application_date'}
  ],
  // 氏名 姓
  surname: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name'},
    {rule: 'string', event: 'input', error_add: 'name'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name'}
  ],
  // 氏名 名
  first_name: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name'},
    {rule: 'string', event: 'input', error_add: 'name'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name'}
  ],
  // 氏名 姓 カナ
  surname_kana: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name_kana'},
    {rule: 'string', event: 'input', error_add: 'name_kana'},
    {rule: 'kana', event: 'blur', error_add: 'name_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name_kana'}
  ],
  // 氏名 名 カナ
  first_name_kana: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'name_kana'},
    {rule: 'string', event: 'input', error_add: 'name_kana'},
    {rule: 'kana', event: 'blur', error_add: 'name_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'name_kana'}
  ],
  // 旧姓 姓
  old_surname: [
    {rule: 'string', event: 'input', error_add: 'old_surname'},
    {rule: 'maxlen:50', event: 'input', error_add: 'old_surname'}
  ],
  // 旧姓 姓 カナ
  old_surname_kana: [
    {rule: 'string', event: 'input', error_add: 'old_surname_kana'},
    // {rule: 'kana', event: 'blur', error_add: 'old_surname_kana'},
    {rule: 'maxlen:50', event: 'input', error_add: 'old_surname_kana'}
  ],
  // 性別
  sex_type: [{rule: 'required', event: 'blur', action: 'radio'}],
  // 生年月日(年)
  birthday_year: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday'},
    {rule: 'date:birthday_month:birthday_day', event: 'blur', error_add: 'application_date'}
  ],
  // 生年月日(月)
  birthday_month: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday'},
    {rule: 'date:birthday_year:birthday_day', event: 'blur', error_add: 'application_date'}
  ],
  // 生年月日(日)
  birthday_day: [
    {rule: 'required', event: 'blur,change', action: 'select', error_add: 'birthday'},
    {rule: 'date:birthday_year:birthday_month', event: 'blur', error_add: 'application_date'}
  ],
  // 郵便番号
  post_number: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'post', event: 'blur'}
  ],
  // 郵便番号検索結果
  post_number_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // 住所1
  street_address1: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:120', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 住所2
  street_address2: [
    {rule: 'maxlen:190', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 住所カナ
  street_address_kana: [
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:150', event: 'input'}
  ],
  // 自宅電話番号1
  fixed_phone1: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 自宅電話番号2
  fixed_phone2: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 自宅電話番号3
  fixed_phone3: [
    {rule: 'integer', event: 'input', error_add: 'fixed_phone'},
    {rule: 'string', event: 'input', error_add: 'fixed_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'fixed_phone'}
  ],
  // 携帯番号1
  mobile_phone1: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // 携帯番号2
  mobile_phone2: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // 携帯番号3
  mobile_phone3: [
    {rule: 'required', event: 'blur', action: 'input', error_add: 'mobile_phone'},
    {rule: 'integer', event: 'input', error_add: 'mobile_phone'},
    {rule: 'string', event: 'input', error_add: 'mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'mobile_phone'}
  ],
  // // 配偶者
  // has_spouse: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 親同伴
  // parent_living: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 子供あり
  // child_status: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // 子供人数
  // child_number: [
  //     { rule: 'required_if:child_status,有', event: 'blur', action: 'input' },
  // ],
  // // その他あり
  // others_status: [
  //     { rule: 'required', event: 'change', action: 'radio' },
  // ],
  // // その他人数
  // others_number: [
  //     { rule: 'required_if:others_status,有', event: 'blur', action: 'input' },
  // ],
  // ご家族について
  family_about: [{rule: 'required', event: 'blur,change', action: 'select'}],
  // ご家族についての同居人数
  family_about_number: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'integer', event: 'input'},
    {rule: 'max:2', event: 'input'},
    {rule: 'limit:1,lower,人', event: 'input', message: '同居人数は申込者本人も含みます。'}
  ],
  // 実家住所 郵便番号検索結果
  parents_post_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // お勤め先・学校について
  occupation: [{rule: 'required', event: 'blur', action: 'select'}],
  // お勤め先・学校について　その他の場合のテキスト
  occupation_other_name: [
    {rule: 'required_if:occupation,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'inpuut'},
    {rule: 'maxlen:50', event: 'inpuut'}
  ],
  // 学生の無職フラグ（学生でアルバイトしていない方のチェックに対応）
  student_unemployed_flg: [
    {rule: 'required', event: 'blur', action: 'input'},
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'integer', event: 'input', error_add: 'company_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'company_phone'},
    {rule: 'string', event: 'input', error_add: 'company_phone'}
  ],
  // お勤め先名
  company_name: [
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'company_kana', event: 'blur'},
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // 仕事内容　その他の場合のテキスト
  company_job_description_other_name: [
    {rule: 'required_if:company_job_description,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'inpuut'},
    {rule: 'maxlen:50', event: 'inpuut'}
  ],
  // 所属部課
  job_department: [
    {rule: 'maxlen:40', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 出向派遣元
  dispatched_agent: [
    {rule: 'maxlen:40', event: 'input'},
    {rule: 'string', event: 'input'}
  ],
  // 勤め先郵便番号
  company_post: [{rule: 'post', event: 'input'}],
  // 勤め先郵便番号検索結果
  company_post_search: [{rule: 'message_custom:住所が見つかりませんでした。再度ご確認ください', event: 'blur'}],
  // 勤め先住所
  company_address: [
    {rule: 'address', event: 'blur'},
    {rule: 'string', event: 'blur'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // 税込年収
  company_income: [
    {rule: 'integer', event: 'input'},
    {rule: 'more:1',event: 'blur', action: 'input'},
  ],
  // その他収入(年額) のその他テキスト
  sideline_other_name: [
    {rule: 'required_if:sideline_type,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'blur'},
    {rule: 'maxlen:40', event: 'input'}
  ],
  // その他収入 税込年収
  sideline_income: [{rule: 'integer', event: 'input'}]
}

/**
 * 【管理画面】顧客情報修正モーダルのバリデーション信販
 */
export const ValidationRulesCredit = {
  // 取引を行う目的
  purpose_of_transaction: [{rule: 'required', event: 'blur', action: 'select'}],
  // 取引を行う目的 その他の場合のテキスト
  purpose_of_transaction_other_name: [
    {rule: 'required_if:purpose_of_transaction,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],

  // 外国政府等重要な公的地位にある方等とのお取引に該当する
  is_foreign_government: [{rule: 'required', event: 'blur', action: 'radio', error_add: 'is_foreign_government'}],
  // 外国政府等重要な公的地位にある方等とのお取引に該当する (国、職名)
  foreign_government_company: [
    {
      rule: 'required_if:is_foreign_government,はい',
      event: 'blur',
      action: 'input',
      error_add: 'foreign_government_company'
    },
    {rule: 'string', event: 'input', error_add: 'foreign_government_company'},
    {rule: 'max:50', event: 'input', error_add: 'foreign_government_company'}
  ],
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生計同一人数
  family_structure: [
    {rule: 'required', event: 'blur,change', action: 'select'}
    // { rule: 'required', event: 'change', action: 'select' },
  ],
  // 住宅ローン・家賃のお支払い
  loan_rent: [{rule: 'required', event: 'blur', action: 'radio'}],
  // お申込者と世帯主の関係
  householder_relation: [{rule: 'required', event: 'blur', action: 'select'}],
  // 世帯主の税込年収
  householder_income: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'select'
    },
    {rule: 'integer', event: 'input'}
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur', action: 'select' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur', action: 'select' },
  ],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}],
  // 世帯主の所得種類
  householder_income_type: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur,change',
      action: 'select'
    }
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur,change', action: 'select' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur,change', action: 'select' },
  ],
  // 世帯主の所得種類 その他の場合のテキスト
  householder_income_type_other_name: [
    {
      rule: `required_if:householder_income_type,その他&occupation,専業主婦|householder_income_type,その他&householder_relation,配偶者|householder_income_type,その他&occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'input'
    },
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
    // { rule: 'required_if:householder_income_type,その他&householder_relation,配偶者', event: 'blur', action: 'input' },
    // { rule: 'required_if:householder_income_type,その他&occupation,学生&householder_relation,配偶者', event: 'blur', action: 'input' },
  ],
  // 世帯主のクレジット月間支払い額
  householder_monthly_credit_payments: [
    {
      rule: `required_if:occupation,専業主婦|householder_relation,配偶者|occupation,学生（アルバイト）&householder_relation,配偶者`,
      event: 'blur',
      action: 'input'
    },
    {rule: 'integer', event: 'input'}
    // { rule: 'required_if:householder_relation,配偶者', event: 'blur', action: 'input' },
    // { rule: 'required_if:occupation,学生&householder_relation,配偶者', event: 'blur', action: 'input' },
  ],
  // 実家住所 郵便番号
  parents_post: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'post', event: 'input'}
  ],
  // 実家住所
  parents_address: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:190', event: 'input'}
  ],
  /// 実家電話番号1
  parents_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号2
  parents_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号3
  parents_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家携帯電話番号1
  parents_mobile_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号2
  parents_mobile_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号3
  parents_mobile_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話続柄
  parents_phone_relationship: [
    {rule: 'string', event: 'blur', error_add: 'parents_phone_relationship'},
    {rule: 'maxlen:50', event: 'input', error_add: 'parents_phone_relationship'}
  ],
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
  // 卒業予定(年)
  graduate_year: [
    {rule: 'required_if:occupation,学生（アルバイト）', event: 'blur,change', action: 'select'}
  ],
  // 卒業予定(月)
  graduate_month: [
    {rule: 'required_if:occupation,学生（アルバイト）', event: 'blur,change', action: 'select'}
  ],
  // お勤め先名
  company_name: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先カナ
  company_name_kana: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'select'}],
  // 勤め先郵便番号
  company_post: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}],
  // 勤め先住所
  company_address: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_address'}
  ],
  // 入社年月(年)
  join_year: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'select'},
  ],
  // 入社年月(月)
  join_month: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'select'}],
  // 給料日
  payday: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'select'}],
  // 税込年収
  company_income: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}]
}

/**
 * 【管理画面】顧客情報修正モーダルのバリデーション自社割賦
 */
export const ValidationRulesInstallment = {
  // 生計同一人数
  family_structure: [
    {rule: 'required', event: 'blur,change', action: 'select'}
  ],
  // お申込者と世帯主の関係
  householder_relation: [
    {rule: 'required', event: 'blur', action: 'select'}
  ],
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // お勤め先名
  company_name: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'select'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'select'}
  ],
  // 税込年収
  company_income: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}],
  // 実家住所 郵便番号
  parents_post: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'post', event: 'input'}
  ],
  // 実家住所
  parents_address: [
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'address', event: 'blur'},
    {rule: 'maxlen:190', event: 'input'}
  ],
  /// 実家電話番号1
  parents_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号2
  parents_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家電話番号3
  parents_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_phone'}
  ],
  /// 実家携帯電話番号1
  parents_mobile_phone1: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号2
  parents_mobile_phone2: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話番号3
  parents_mobile_phone3: [
    {rule: 'integer', event: 'input', error_add: 'parents_mobile_phone'},
    {rule: 'string', event: 'blur', error_add: 'parents_mobile_phone'},
    {rule: 'maxlen:5', event: 'input', error_add: 'parents_mobile_phone'}
  ],
  /// 実家携帯電話続柄
  parents_phone_relationship: [
    {rule: 'string', event: 'blur', error_add: 'parents_phone_relationship'},
    {rule: 'maxlen:50', event: 'input', error_add: 'parents_phone_relationship'}
  ],
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
}

/**
 * 個人情報入力画面のバリデーション信販追加申込
 */
export const ValidationRulesAddCredit = {
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.credit.low}~${AgeLimit.credit.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // お勤め先名
  company_name: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先カナ
  company_name_kana: [{rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input'}],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 実家携帯電話の続柄(その他)
  parents_phone_relationship_other_name: [
    {rule: 'required_if:parents_phone_relationship,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'max:50', event: 'input'}
  ],
}

/**
 * 個人情報入力画面のバリデーション自社割賦追加
 */
export const ValidationRulesAddInstallment = {
  // 生年月日(年)
  birthday_year: [
    {
      rule: `birthday_range:birthday_month,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(月)
  birthday_month: [
    {
      rule: `birthday_range:birthday_year,birthday_day:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // 生年月日(日)
  birthday_day: [
    {
      rule: `birthday_range:birthday_month,birthday_year:${AgeLimit.installment.low}~${AgeLimit.installment.high}`,
      event: 'blur',
      error_add: 'birthday'
    }
  ],
  // お勤め先名
  company_name: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先カナ
  company_name_kana: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // お勤め先電話番号
  company_phone1: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone2: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // お勤め先電話番号
  company_phone3: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input', error_add: 'company_phone'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input', error_add: 'company_phone'}
  ],
  // 仕事内容
  company_job_description: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'select'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'select'}
  ],
  // 税込年収
  company_income: [
    {rule: 'required_unless:occupation,無職,専業主婦,学生（アルバイト）', event: 'blur', action: 'input'},
    {rule: 'required_if:occupation,学生（アルバイト）&student_unemployed_flg,false', event: 'blur', action: 'input'}
  ],
  // ご住居
  residence_classification: [{rule: 'required', event: 'blur', action: 'select'}],
  // 居住年数
  residence_period_year: [{rule: 'required', event: 'blur', action: 'select'}]
}
